const CommitteeCard = ({ member, isLeader = false, small = false }) => {
  const baseClasses = `
    group relative backdrop-blur-xl rounded-[1.25rem] 
    shadow-[0_15px_30px_rgba(8,112,184,0.2)]
    dark:shadow-[0_15px_30px_rgba(79,70,229,0.15)]
    hover:shadow-[0_20px_40px_rgba(8,112,184,0.3)]
    dark:hover:shadow-[0_20px_40px_rgba(79,70,229,0.25)]
    transition-all duration-500 text-center border 
    border-blue-100/60 dark:border-blue-900/30 overflow-hidden
  `;

  // Choose padding & scale
  const sizeClasses = isLeader
    ? "p-8 scale-105"
    : small
    ? "p-4 scale-95"
    : "p-6";

  // Choose image size
  const imageSize = isLeader ? "w-32 h-32" : small ? "w-24 h-24" : "w-32 h-32";

  return (
    <div className={`${baseClasses} ${sizeClasses}`}>
      {/* Accent bar */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-blue-500 via-indigo-600 to-violet-500"></div>

      {/* Profile */}
      <div className={`relative ${imageSize} mx-auto mb-6`}>
        <img
          src={member.image}
          alt={member.name}
          className="w-full h-full object-cover rounded-full border-4 border-white dark:border-gray-800 group-hover:scale-105 transition-all duration-500"
          onError={(e) => {
            e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
              member.name
            )}&background=3B82F6&color=ffffff&size=200`;
          }}
        />
      </div>

      {/* Name */}
      <h3
        className={`
        ${small ? "text-lg" : "text-xl"} 
        font-bold text-gray-900 dark:text-white mb-3
        group-hover:bg-gradient-to-r group-hover:from-blue-600 
        group-hover:via-indigo-600 group-hover:to-violet-600 
        group-hover:bg-clip-text group-hover:text-transparent transition-all duration-500`}
      >
        {member.name}
      </h3>

      {/* Position */}
      <div
        className={`
        ${small ? "text-xs px-3 py-1.5" : "text-sm px-4 py-2"} 
        text-blue-600 dark:text-blue-400 font-medium uppercase tracking-wider 
        bg-blue-50/70 dark:bg-blue-900/30 rounded-full 
        shadow-[0_2px_6px_rgba(8,112,184,0.1)] dark:shadow-[0_2px_6px_rgba(79,70,229,0.1)]
        inline-block group-hover:bg-blue-100/80 dark:group-hover:bg-blue-900/50 transition-colors duration-300`}
      >
        {member.position}
      </div>
    </div>
  );
};

export default CommitteeCard;
